var map = {
	"./item-0.png": 1496,
	"./item-1.png": 1497,
	"./item-2.png": 1498,
	"./item-3.png": 1499,
	"./item-4.png": 1500,
	"./item-5.png": 1501,
	"./item-6.png": 1502,
	"./item-7.png": 1503
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1134;